import icon from '../../../../includes/primitives/icons'
export default {
  data: () => ({

    icon: icon.arrow,
    
    rawData:  [],
    
    table: null,
    columns: null,
    keys: null,
    filters: null,
    
    canvasForms:  null,

  }),


  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

}